module.exports = __webpack_public_path__ + "img/bg_share_1.4da7ac71.png";